import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import { getGlobalMobileClasses } from '../../themes';
import AuthUserContainer from '../../containers/AuthUser';
import { commodityCodeToDisplay } from './common/commodities';

//const stlBlue = '#1289d4';
const styles = (theme) => {
	return {
		...getGlobalMobileClasses(theme),
	};
};

class DebugCommodities extends Component {
	render() {
		return (
			<table style={{ margin: 10 }}>
				{Object.keys(commodityCodeToDisplay).map((cmdCode) => {
					const cmd = commodityCodeToDisplay[cmdCode];

					return (
						<tr style={{ padding: 3 }}>
							<td style={{ paddingRight: 5 }}>{cmdCode}</td>
							<td>
								<span
									style={{
										borderRadius: 20,
										backgroundColor: cmd.bg,
										color: 'white',
										padding: '3px 12px',
										fontSize: '80%',
										fontWeight: 1000,
										textTransform: 'uppercase',
										marginRight: 10,
									}}
								>
									{cmd.abbr}
								</span>
							</td>
						</tr>
					);
				})}
			</table>
		);
	}
}

DebugCommodities.propTypes = {
	authUser: PropTypes.object,
};
export default _.flow([withStyles(styles), AuthUserContainer])(DebugCommodities);
